import * as React from 'react';
import { css } from 'react-strict-dom';

import Text from './Text';

type Props = Readonly<{
  children: React.ReactNode;
}>;

export default function EmptyMessage({ children }: Props) {
  return (
    <Text as="p" style={styles.message}>
      {children}
    </Text>
  );
}

const styles = css.create({
  message: {
    fontSize: '1.0625rem',
    textAlign: 'center',
    paddingBlock: 50,
    color: '#999',
  },
});
